import { useCallback, useContext, useState } from 'react'
import AuthContext from "../context/AuthProvider";
import AuthService from '../services/AuthService';
import jwt_decode from "jwt-decode";
import { useNavigate, useLocation } from 'react-router-dom';


const useAuth = () => {
  const { accessToken, setAccessToken, user, setUser } = useContext(AuthContext);
  const [state, setState] = useState({ error: false })
  const [loading, setLoading] = useState(false);

  //Navigate
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from.pathname || "/";


  const login = useCallback((data) => {
    setLoading(true);
    AuthService.login(data)
      .then(accessToken => {
        window.sessionStorage.setItem('accessToken', accessToken)
        setState({ error: false })
        setAccessToken(accessToken);
        setUser(jwt_decode(accessToken));
        setLoading(false);
      })
      .catch(error => {
        window.sessionStorage.removeItem('accessToken')
        setState({ error: error.message });
        setLoading(false);
      })
  }, [setAccessToken])

  const logout = useCallback(() => {
    window.sessionStorage.removeItem('accessToken')
    setAccessToken(null);
    navigate(from, { replace: true });
  }, [setAccessToken]);

  let refreshToken = function refreshPromise() {
    return new Promise((resolve, reject) => {
      AuthService.refreshToken().then(accessToken => {
        window.sessionStorage.setItem('accessToken', accessToken);
        setAccessToken(accessToken);
        setUser(jwt_decode(accessToken));
        resolve("");
      }).catch(()=>reject(""))
    })
  }

  return {
    user,
    setUser,
    login,
    isLogged: Boolean(accessToken),
    loginError: state.error,
    logout,
    refreshToken,
    loading: loading
  }
}

export default useAuth;